import { render } from "./Events.vue?vue&type=template&id=7ba168e6&scoped=true&ts=true"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"

import "@/assets/scss/report-grid.scss?vue&type=style&index=0&id=7ba168e6&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba168e6"]])

export default __exports__